/**
 *  Multi-language Free Shipping Progress Bar
 *  Supports: NL, EN, DE, FR
 */

if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const locale = this.dataset.locale || Shopify.locale || 'nl';

      const translations = {
        nl: {
          remaining: "Nog <span></span> tot gratis verzending",
          full: "🎉 Je hebt gratis verzending verdiend!"
        },
        en: {
          remaining: "Only <span></span> left for free shipping",
          full: "🎉 You've unlocked free shipping!"
        },
        de: {
          remaining: "Nur noch <span></span> bis zum kostenlosen Versand",
          full: "🎉 Du hast kostenlosen Versand erreicht!"
        },
        fr: {
          remaining: "Plus que <span></span> pour la livraison gratuite",
          full: "🎉 Vous avez obtenu la livraison gratuite !"
        }
      };

      const t = translations[locale] || translations.nl;

      const remainingEl = this.querySelector('.free-shipping--text-remaining');
      const fullEl      = this.querySelector('.free-shipping--text-full');
      const barFill     = this.querySelector('.free-shipping__bar-fill');

      // Inject translations
      remainingEl.innerHTML = t.remaining;
      fullEl.innerHTML = t.full;

      // Span voor bedrag
      const amountSpan = remainingEl.querySelector('span');

      let total    = parseInt(this.dataset.cartTotal, 10);
      let minimum  = parseInt(this.dataset.minimum, 10);

      let percentage = Math.min(total / minimum, 1);

      if (total < minimum) {
        const remaining = minimum - total;
        let format = window.theme.settings.money_with_currency_format || "${{amount}}";

        amountSpan.innerHTML = formatMoney(remaining, format);

        remainingEl.style.display = "block";
        fullEl.style.display = "none";
      } else {
        remainingEl.style.display = "none";
        fullEl.style.display = "block";
      }

      if (barFill) {
        barFill.style.width = (percentage * 100) + "%";
      }
    }
  }

  customElements.define('free-shipping', FreeShipping);
}
